import React, { useEffect, useState } from "react";
import BannerCard from "./BannerCard";
import "./BannerCarousel.css";
import { getBanners, getBannerPath, getBannerObject } from "./ParseBannersService"
import { Loading } from '../Loading/Loading';

export default function BannerCarousel({
    context,
    onBannerClick
}) {

    const [banners, setBanners] = useState([]);

    const [bannerCarousel, setBannerCarousel] = useState([])
    const [loading, setLoading] = useState(false);



    useEffect(() => {
        getBannersData();
    }, []);

    useEffect(() => {
        makeRequest();
    }, [banners]);

    const getBannersData = async () => {
        setLoading(true);
        try {
            const { idToken } = context;

            const headers = {
                Authorization: `Bearer ${idToken}`
            };

            const response = await fetch("/Banners/GetBanners", { headers });

            if (!response.ok) {
                setBanners([]);
                return;
            }

            const data = await response.json();
            const dataJson = JSON.parse(data.bannersContent);
            const bannersList = getBanners(dataJson);
            const banners = bannersList.map((banner) => (
                { ...banner, path: getBannerPath(banner) }
            ));

            setBanners(banners);

        } catch (error) {
            console.error("Error fetching protection data:", error);
            setBanners([]);
            setLoading(false);
        }
    }

    const makeRequest = async () => {

        try {
            let resultTemp = [];
            for (const item of banners) {

                const { idToken } = context;
                const headers = {
                    Authorization: `Bearer ${idToken}`
                };
                console.log("-> ", item);

                const requestUrl = `/Banners/GetBanner?path=${item.path}`;
                const resp = await fetch(requestUrl, { headers });

                if (!resp.ok) {
                    throw new Error(`Erro na chamada: ${item.path} ${resp}`);
                }

                const data = await resp.json();
                const dataJson = JSON.parse(data.bannersContent);

                const bannerObject = getBannerObject(dataJson);
                console.log("--> ", bannerObject);

                resultTemp.push(bannerObject);
            }


            setBannerCarousel(resultTemp);
        } catch (error) {
            console.error("Erro ao executar as chamadas:", error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="banner-carousel-container">
            {loading ? (
                <Loading />
            ) : (
                bannerCarousel.length > 0 && (
                    <>
                        <span className="banner-carousel-title">Mais para si</span>
                        <div className="banner-carousel">
                            <div className="banner-carousel__content">
                                {bannerCarousel.map((banner) => (
                                    <BannerCard
                                        key={banner.url}
                                        banner={banner.url}
                                        onClick={() => onBannerClick?.(banner)}
                                    />
                                ))}
                            </div>
                        </div>
                    </>
                )
            )}
        </div>
    );

}